import { generatePath } from "react-router-dom";
import routing from "routing";

import { hasServiceParam } from "./isPes";

export function useHasRequiredCookies(shouldCheck = true) {
	if (!hasServiceParam && shouldCheck) {
		redirect(generatePath(routing.paths.login));
		return false;
	}

	return true;
}

export function redirect(href) {
	location.href = href;
}
